<template><div><h1>文档是用什么工具编写的？</h1>
<p>早期版本使用的是 <a href="https://docute.js.org">Docute</a> by <a href="https://github.com/egoist">egoist</a>。在<code>Docute</code>基础上做了一点样式修改。</p>
<p>2.2.1 后面版本出于 <code>SEO</code> 考虑使用 <code>Vue</code> 的服务端渲染，使用的框架同样是 <a href="https://github.com/egoist">egoist</a> 开发的 <a href="https://github.com/ream/ream">ream</a>。</p>
<p>文档部分样式参照了 <a href="https://eggjs.org/">eggjs.org</a>，表示感谢。</p>
<p>因此目前无论是组件还是文档都是完全基于 <code>Vue</code>，cool right?</p>
</div></template><script>
export default {
  head: {"title":"文档是用什么工具编写的？ | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// document-framework-14.vue?44fb5fc7